export const defaultConfig = {
    title: "Tenant/Business Name",
    fields: [
      {
        row: 1,
        items: [
          {
            name: "vendor_name",
            placeholder: "Vendor Full Name",
            type: "text",
            required: false,
          },
          {
            name: "email",
            placeholder: "Email Address",
            type: "email",
            required: false,
          },
          {
            name: "phone",
            placeholder: "Phone Number",
            type: "phone",
            required: false,
          },
        ],
      },
      {
        row: 2,
        items: [
          {
            name: "businessName",
            placeholder: "Business Name",
            type: "text",
            required: false,
          },
          {
            name: "industry",
            placeholder: "Industry",
            type: "text",
            required: false,
          },
          {
            name: "platform",
            placeholder: "E-commerce Platform",
            type: "text",
            required: false,
          },
        ],
      },
    ],
    interestOptions: [
      { value: "free_demo", label: "Free demo" },
      { value: "integration", label: "Integrating my store on Zory for recommendation" },
      { value: "api", label: "Using Zory APIs for my own website" },
      { value: "other", label: "Other" },
    ],
    includeDescription: true,
    includeTenantStatus: true,
    buttons: {
      cancel: {
        text: "Cancel",
        style: {}
      },
      submit: {
        text: "Update",
        style: {}
      }
    }
  };
  
  // Function to generate validation rules based on field type
  export const getValidationRules = (field) => {
    const rules = [];
    
    if (field.required) {
      rules.push({
        required: true,
        message: `Please enter ${field.placeholder}`,
      });
    }
    
    if (field.type === "email") {
      rules.push({
        type: "email",
        message: "Please enter a valid email address",
      });
    }
    
    return rules;
  };
  
  // Helper function to get placeholder text for description
  export const getDescriptionPlaceholder = () => {
    return "Enter description here...";
  };